import { render, staticRenderFns } from "./main-menu.vue?vue&type=template&id=5125794b&scoped=true"
import script from "./main-menu.vue?vue&type=script&lang=js"
export * from "./main-menu.vue?vue&type=script&lang=js"
import style0 from "./main-menu.vue?vue&type=style&index=0&id=5125794b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125794b",
  null
  
)

export default component.exports